import {
    REQUEST_VEHICLE_AVAILABLE, REQUEST_VEHICLE_AVAILABLE_FAILURE,
    REQUEST_VEHICLE_AVAILABLE_SUCCESS
} from "../../../constant/transaction/ShipmentConstant";


const initialState = {
    vehicleAvailable: {
        data: [],
        status: 'idle',
        isLoading: true,
    },
};


export const vehicleAvailableReducer = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case REQUEST_VEHICLE_AVAILABLE:
            return {
                ...state,
                vehicleAvailable: {
                    data: [],
                    status: 'fetching',
                    isLoading: true,
                },
            };
        case REQUEST_VEHICLE_AVAILABLE_SUCCESS:
            return {
                ...state,
                vehicleAvailable: {
                    data: payload,
                    status: 'ready',
                    isLoading: false,
                },
            };
        case REQUEST_VEHICLE_AVAILABLE_FAILURE:
            return {
                ...state,
                vehicleAvailable: {
                    data: [],
                    status: 'fetching',
                },
            };
        default:
            return state;
    }
}
